import { Injectable } from "@angular/core";
import { FormFile } from "../model/file.model";
import { ApiClient } from "../service/network/api.client";

@Injectable({
	providedIn: "root",
})
export class CdnApi {
	constructor(private readonly apiClient: ApiClient) {}

	public async uploadTexture(file: FormFile, fileId: string) {
		const formData = new FormData();
		formData.append("id", fileId);
		formData.append("file", file.file);
		formData.append("filename", file.filename);
		formData.append("mimetype", file.mimeType);

		await this.apiClient.post("/cdn/upload/texture", formData);
	}

	public async uploadProfile(file: FormFile, fileId: string) {
		const formData = new FormData();
		formData.append("id", fileId);
		formData.append("file", file.file);
		formData.append("filename", file.filename);
		formData.append("mimetype", file.mimeType);

		await this.apiClient.post("/cdn/upload/profile", formData);
	}

	public async uploadPdf(file: FormFile, fileId: string) {
		const formData = new FormData();
		formData.append("id", fileId);
		formData.append("file", file.file);
		formData.append("filename", file.filename);
		formData.append("mimetype", file.mimeType);

		await this.apiClient.post("/cdn/upload", formData);
	}
}
